const isNonNumericEmail = (email: string) => {
  // Check if the email is valid
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return false;
  }
  // check if the email has at least one non-numeric character
  const localPart = email.split("@")[0];
  return !localPart?.match(/^\d+$/);
};

export default isNonNumericEmail;
